import { createSelector } from 'reselect';
import { reduxKey } from './constants';
import { AppEnvironment } from './types';

function getSlice(state: any): AppEnvironment {
  if (!state[reduxKey]) {
    return {} as any;
  }
  return state[reduxKey];
}

export const getEnv = createSelector(getSlice, slice => {
  return slice;
});
